import React from 'react';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-ink-800 px-4 py-10 sm:px-6 sm:py-14" data-id="element-207" data-mp="3uudx5tbejziq">
      <div className="mx-auto max-w-5xl text-center" data-id="element-208" data-mp="3uwgn6dck1sng">
        <p className="inline-block rounded-full border border-gold-500/40 bg-ink-700 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold-500 sm:text-xs" data-id="element-209" data-mp="cng1oereb36u">
          🏆 Sistema Stock Cero™
        </p>

        <h2 className="mt-3 text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-210" data-mp="3g5hhpb70nk83">
          2 Tomos + 10 Bonos
        </h2>
        <p className="mt-1.5 text-sm font-semibold text-gold-400 sm:text-base" data-id="element-211" data-mp="3pure338w7p20">
          Herramientas listas para usar. Sin teoría. Sin excusas.
        </p>

        <ul className="mt-6 grid gap-3 text-left md:grid-cols-2" data-id="element-212" data-mp="3l2zrf3suy3h5">
          {volumes.map(volume => <li key={volume.title} className="flex flex-col rounded-xl border border-white/10 bg-ink-700 p-5" data-id="element-213" data-mp="2xcnbp6rdf2g0">
              <h3 className="text-sm font-extrabold uppercase leading-snug text-white sm:text-base" data-id="element-214" data-mp="29ga5prbmhfp8">
                <span aria-hidden="true" data-id="element-215" data-mp="2edjvj82xbtdl">{volume.icon}</span> {volume.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-neutral-400" data-id="element-216" data-mp="2j51whw4y5tyk">
                {volume.description}
              </p>
              <ul className="mt-4 space-y-1.5" data-id="element-217" data-mp="2o3lj7yrd79rz">
                {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-neutral-300" data-id="element-218" data-mp="1qih54voh1hv0">
                    <span aria-hidden="true" className="text-gold-500" data-id="element-219" data-mp="20ekikxorx2x9">
                      ·
                    </span>
                    {item}
                  </li>)}
              </ul>
            </li>)}
        </ul>
      </div>
    </section>;
}